/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PinnedBubble
 */
export interface PinnedBubble {
    /**
     * 
     * @type {string}
     * @memberof PinnedBubble
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedBubble
     */
    notes?: string;
}

/**
 * Check if a given object implements the PinnedBubble interface.
 */
export function instanceOfPinnedBubble(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PinnedBubbleFromJSON(json: any): PinnedBubble {
    return PinnedBubbleFromJSONTyped(json, false);
}

export function PinnedBubbleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PinnedBubble {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function PinnedBubbleToJSON(value?: PinnedBubble | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'notes': value.notes,
    };
}

